import * as Sentry from '@sentry/nextjs';

import withPageBanner from '@/components/core/withPageBanner';
import Content from '@/components/ui/main/simple-content';
import RichText from '@/components/rich-text-markdown';
import Seo from '@/components/shared/SEO';

import { getHipaaNoticeOfPrivacyPracticesPage } from '@/services/legal-documents.service';
import { getNavigation } from '@/services/navigation';

export default function TermsAndConditions({ contentPrefetch }) {
  const { seo, title, content } = contentPrefetch;
  return (
    <>
      <Seo seo={seo} />

      <Content title={title}>
        <RichText content={content} />
      </Content>
    </>
  );
}

export const getStaticProps = withPageBanner(async () => {
  try {
    const contentPrefetch = await getHipaaNoticeOfPrivacyPracticesPage();
    const navigation = await getNavigation();

    return {
      props: {
        contentPrefetch,
        navigation,
      },
      revalidate: 60,
    };
  } catch (error) {
    Sentry.captureException(error);

    if (error.response?.status === 404) {
      return {
        notFound: true,
        revalidate: 60,
      };
    }

    throw new Error('Failed to fetch HIPAA notice of privacy practices data');
  }
});
